import type { PickersInputComponentLocaleText } from '@mui/x-date-pickers/locales';
import { useTranslation } from 'react-i18next';

export const useDatePickerLocaleText = (): PickersInputComponentLocaleText<Date> => {
  const { t } = useTranslation();
  return {
    toolbarTitle: t('coreComponents.fields.datePicker.toolbarTitle', 'Select date'),
    cancelButtonLabel: t('coreComponents.fields.datePicker.cancel', 'Cancel'),
    okButtonLabel: t('coreComponents.fields.datePicker.ok', 'OK'),
    clearButtonLabel: t('coreComponents.fields.clear', 'Clear'),
    todayButtonLabel: t('coreComponents.fields.datePicker.today', 'Today'),
    fieldClearLabel: t('coreComponents.fields.clear', 'Clear'),
    previousMonth: t('coreComponents.fields.datePicker.previousMonth', 'Previous month'),
    nextMonth: t('coreComponents.fields.datePicker.nextMonth', 'Next month'),
    openPreviousView: t('coreComponents.fields.datePicker.openPreviousView', 'Open previous view'),
    openNextView: t('coreComponents.fields.datePicker.openNextView', 'Open next view'),
    dateTableLabel: t('coreComponents.fields.datePicker.dateTable', 'pick date'),
    calendarViewSwitchingButtonAriaLabel: (view) =>
      view === 'year'
        ? t('coreComponents.fields.datePicker.yearViewOpen', 'year view is open, switch to calendar view')
        : t('coreComponents.fields.datePicker.calendarViewOpen', 'calendar view is open, switch to year view'),
    openDatePickerDialogue: (_date, _utils, formattedDate) =>
      formattedDate === null
        ? t('coreComponents.fields.datePicker.chooseDate', 'Choose date')
        : t('coreComponents.fields.datePicker.chooseDateSelected', 'Choose date, selected date is {{date}}', { date: formattedDate }),
    fieldDayPlaceholder: () => t('coreComponents.fields.datePicker.dayPlaceholder', 'DD'),
    fieldMonthPlaceholder: ({ contentType }) =>
      contentType === 'letter'
        ? t('coreComponents.fields.datePicker.monthNamePlaceholder', 'MMMM')
        : t('coreComponents.fields.datePicker.monthPlaceholder', 'MM'),
    fieldYearPlaceholder: ({ digitAmount }) => t('coreComponents.fields.datePicker.yearPlaceholderLetter', 'Y').repeat(digitAmount),
  };
};
